/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDRadiusDownRightIcon16Light } from './ArrowDRadiusDownRightIcon16Light';
import { ArrowDRadiusDownRightIcon16Regular } from './ArrowDRadiusDownRightIcon16Regular';
import { ArrowDRadiusDownRightIcon16Solid } from './ArrowDRadiusDownRightIcon16Solid';
import { ArrowDRadiusDownRightIcon20Light } from './ArrowDRadiusDownRightIcon20Light';
import { ArrowDRadiusDownRightIcon20Regular } from './ArrowDRadiusDownRightIcon20Regular';
import { ArrowDRadiusDownRightIcon20Solid } from './ArrowDRadiusDownRightIcon20Solid';
import { ArrowDRadiusDownRightIcon24Regular } from './ArrowDRadiusDownRightIcon24Regular';
import { ArrowDRadiusDownRightIcon24Solid } from './ArrowDRadiusDownRightIcon24Solid';
import { ArrowDRadiusDownRightIcon32Regular } from './ArrowDRadiusDownRightIcon32Regular';
import { ArrowDRadiusDownRightIcon64Regular } from './ArrowDRadiusDownRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDRadiusDownRightIcon16Light,
        regular: ArrowDRadiusDownRightIcon16Regular,
        solid: ArrowDRadiusDownRightIcon16Solid,
    },
    20: {
        light: ArrowDRadiusDownRightIcon20Light,
        regular: ArrowDRadiusDownRightIcon20Regular,
        solid: ArrowDRadiusDownRightIcon20Solid,
    },
    24: {
        regular: ArrowDRadiusDownRightIcon24Regular,
        solid: ArrowDRadiusDownRightIcon24Solid,
    },
    32: {
        regular: ArrowDRadiusDownRightIcon32Regular,
    },
    64: {
        regular: ArrowDRadiusDownRightIcon64Regular,
    },
};
export var ArrowDRadiusDownRightIcon = forwardRef('ArrowDRadiusDownRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
